import {Suspense} from 'react';
import {Outlet, createRoute, redirect} from '@tanstack/react-router';
import {LOGIN} from '@/anonymous/routing/paths';
import NotFoundPage from '@/anonymous/views/error/NotFoundPage';
import PatientLayout from '@/patient/components/layout/PatientLayout';
import PractitionerLayout from '@/practitioner/components/layout/PractitionerLayout';
import AppLoading from '@/shared/components/ui/AppLoading';
import {useIsPatient} from '@/shared/contexts/UserContext/useUserContext';
import {AppRouterContext} from '@/shared/routing';
import handleRedirectCookie from '@/shared/routing/handleRedirectCookie';
import {USER_HOME} from '@/shared/routing/paths';
import {Route as rootRoute} from '../__root';

function SharedRoutesLayoutComponent() {
  const isPatient = useIsPatient();

  return (
    <Suspense fallback={<AppLoading />}>
      {isPatient ? (
        <PatientLayout>
          <Outlet />
        </PatientLayout>
      ) : (
        <PractitionerLayout>
          <Outlet />
        </PractitionerLayout>
      )}
    </Suspense>
  );
}

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/u',
  component: SharedRoutesLayoutComponent,
  errorComponent: NotFoundPage,
  beforeLoad: function ({
    context,
    location: {pathname}
  }: {
    context: AppRouterContext;
    location: {pathname: string};
  }) {
    if (!context.isLoggedIn) {
      throw redirect({to: LOGIN, replace: true});
    }
    handleRedirectCookie({pathname, isLoggedIn: context.isLoggedIn});
    if (pathname === '/u') {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
